// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ULQ_","left":"styles_left__2XN-X","desktopActions":"styles_desktopActions__2EIYJ","title":"styles_title__3sP4g"};